const actions = {
  LIST_SERVICIO: 'LIST_SERVICIO',
  LIST_SERVICIO_SELECTBOX: 'LIST_SERVICIO_SELECTBOX',
  CREATE_SERVICIO: 'CREATE_SERVICIO',
  READ_SERVICIO: 'DREA_SERVICIO',
  UPDATE_SERVICIO: 'UPDATE_SERVICIO',
  DELETE_SERVICIO: 'DELETE_SERVICIO',
  
  servicioList: data => {  
    return {
      type: actions.LIST_SERVICIO,
      data,
    };
  },

  servicioListSelectBox: data => {
    return {
      type: actions.LIST_SERVICIO_SELECTBOX,
      data,
    };
  },

  servicioCreate: data => {
    return {
      type: actions.CREATE_SERVICIO,
      data,
    };
  },

  servicioRead: data => {
    return {
      type: actions.READ_SERVICIO,
      data,
    };
  },

  servicioUpdate: data => {
    return {
      type: actions.UPDATE_SERVICIO,
      data,
    };
  },

  servicioDelete: () => {
    return {
      type: actions.DELETE_SERVICIO,      
    };
  },
  

};

export default actions;
